import ExponeaProvider from "../../providers/ExponeaProvider.jsx";
import BonusProvider from "../../modules/Bonus/components/BonusProvider.jsx";
import MobileFirebaseProvider from "./MobileFirebaseProvider/MobileFirebaseProvider";
import ScrollProvider from "../../providers/ScrollProvider/ScrollProvider.jsx";
import NotificationsContainer from "../../modules/Notifications/NotificationsContainer.jsx";
import Zendesk from "../../modules/Zendesk/Zendesk";
import LocationProvider from "../../providers/LocationProvider/LocationProvider";

function MobileProviders(props) {
    const {children} = props;
    return <>
        <MobileFirebaseProvider>
            <NotificationsContainer
                limit={3}
                position="top-center"
                draggableDirection="y"
                draggablePercent={20}
                closeOnClick={false}
                autoClose={4000}
            />
            <ExponeaProvider/>
            <ScrollProvider>
                <BonusProvider>
                    <Zendesk>
                        <LocationProvider>
                            {children}
                        </LocationProvider>
                    </Zendesk>
                </BonusProvider>
            </ScrollProvider>
        </MobileFirebaseProvider>
    </>
}

export default MobileProviders;
